<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">List of WhatsApp Bots</h4>
          </div>
          <div class="col-4">
            <button class="btn btn-primary btn-icon-text text-white float-right" @click="openNewBotModal">
              <span class="h4 text-white">New Bot</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="bot-listing" class="table">
        <thead>
          <tr>
            <th>Bot Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bot in botData" :key="bot.appId">
            <td>{{ bot.appName }}</td>
            <td>{{ bot.description }}</td>
            <td>
              <span :class="['badge', bot.status === 'active' ? 'badge-success' : 'badge-warning']">
                {{ bot.status }}
              </span>
            </td>
            <td>
              <router-link class="btn btn-outline-primary ml-2" :to="'/whatsapp-bot/settings/' + bot.appId"
                data-toggle="tooltip" title="Bot Settings">
                <i class="fa fa-cogs"></i>
              </router-link>
              <button class="btn btn-outline-danger ml-2" @click="deleteBot(bot.appId)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- New Bot Modal -->
    <div class="modal fade" id="newBotModal" tabindex="-1" role="dialog" aria-labelledby="newBotModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newBotModalLabel">Create New WhatsApp Bot</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="bot-form">
              <div class="form-group mb-2">
                <label class="col-form-label">Bot Name:</label>
                <input type="text" class="form-control" v-model="newBotData.appName" />
              </div>
              <div class="form-group mb-2">
                <label class="col-form-label">Description:</label>
                <textarea class="form-control" v-model="newBotData.description" rows="3"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success text-white" @click="createNewBot">
              Create Bot
            </button>
            <button type="button" class="btn btn-light" @click="closeModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import botApi from "@/shared/botApi";

export default {
  name: "WhatsappBotList",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      botData: [],
      newBotData: {
        appName: "",
        description: "",
        botType: "whatsapp"
      }
    };
  },
  methods: {
    getBots() {
      botApi
        .getAllWhatsappBots()
        .then((response) => {
          if(response.error) {
            this.$router.push("/login");
            return;
          }
          this.botData = response.data;
        })
        .catch((error) => {
          console.log("Error", error);
          this.toast.error(error.message);
        });
    },
    openNewBotModal() {
      this.newBotData = {
        appName: "",
        description: "",
        botType: "whatsapp"
      };
      jQuery("#newBotModal").modal("show");
    },
    closeModal() {
      jQuery("#newBotModal").modal("hide");
    },
    createNewBot() {
      botApi
        .createWhatsappBot(this.newBotData)
        .then((response) => {
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getBots();
            this.closeModal();
          } else {
            this.toast.error(response.message);
          }
        })
        .catch((error) => {
          this.toast.error(error.message);
        });
    },
    deleteBot(id) {
      if (confirm("Are you sure you want to delete this bot?")) {
        botApi
          .deleteWhatsappBot(id)
          .then((response) => {
            this.getBots();
            this.toast.success(response.message);
          })
          .catch((error) => {
            this.toast.error(error.message);
          });
      }
    }
  },
  mounted() {
    this.getBots();
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.table-responsive {
  margin-top: 20px;
}

.bot-form .form-group {
  margin-bottom: 0.5rem;
}

.modal-body {
  padding: 1rem;
}
.badge-success {
  background-color: #28a745;
  color: #fff;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-primary {
  background-color: #135475;
  color: #dce3eb;
}

.badge-danger {
  background-color: #dc3545;
  color: #fff;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}
</style> 